export default {"src":"/_next/static/media/clown_64.32cc3798.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};